import { makeAutoObservable } from 'mobx'
import { makePersistable } from 'mobx-persist-store'

interface PathToBronzeData {
  pathToBronzeActive: boolean
  // Which payout tier the user picked in the "Set Monthly Amount" dropdown
  // (3..6 qualifying legs). null renders the '-' placeholder and pays nothing,
  // mirroring the PY27 Excel where the income row stays empty until a selection.
  pathToBronzeSelectedLegs: number | null
}

export class PathToBronzeStore implements PathToBronzeData {
  pathToBronzeActive!: boolean
  pathToBronzeSelectedLegs!: number | null

  constructor() {
    this.reset()
    makeAutoObservable(this, {}, { autoBind: true })
    makePersistable(this, {
      name: `${AIS_STORE}-PathToBronze`,
      properties: ['pathToBronzeActive', 'pathToBronzeSelectedLegs']
    })
  }

  reset() {
    this.pathToBronzeActive = true
    this.pathToBronzeSelectedLegs = null
  }

  setPathToBronzeActive(value: boolean) {
    this.pathToBronzeActive = value
  }

  setPathToBronzeSelectedLegs(value: number | null) {
    this.pathToBronzeSelectedLegs = value
  }
}
